import $ from 'jquery'
let loadingInterval

export function loading (seconds = 0.5) {
  $('.loadingCard').slideDown() // show loading, HTML div
  // $('input').attr({ disabled: true }).addClass('disabled') // disable input
  document.querySelectorAll('input')
    .forEach(e => {
      e.classList.add('disabled')
      e.setAttribute('disabled', true)
    })

  loadingInterval = setInterval(() => {
    const limit = 3
    const content = $('.loadingCard')[0].innerHTML
    const dotsNumber = (content.match(/\./g) || []).length

    $('.loadingCard')[0].innerHTML = content.replace(/\./g, '') + '.'.repeat(dotsNumber >= limit ? 0 : dotsNumber + 1)
  }, seconds * 1000)
}

export function unloading () {
  $('.loadingCard').slideUp() // hide loading, HTML div
  // $('input').attr({ disabled: false }).removeClass('disabled') // enable the input
  document.querySelectorAll('input[disabled]')
    .forEach(e => {
      e.classList.remove('disabled')
      e.removeAttribute('disabled')
    })
  if (loadingInterval) clearInterval(loadingInterval)
}

// show thank you page
export function subscribe () {
  $('.loadingCard').addClass('hidden')
  loading()
  $('form').slideUp()
  $('.thankyou').slideDown()
}
/**
 * timeout is to shake the input longer than the form
 * @param {HTML element} form form to shake
 * @param {HTML element} input input to shake
 */
export function shaker (form, input) {
  form.classList.add('shakeMe')
  setTimeout(function () {
    input.classList.add('shakeMe')
  }, 500)
  setTimeout(function () {
    form.classList.remove('shakeMe')
    input.classList.remove('shakeMe')
  }, 2500)
}
// handling pulse and red border logic on both input and button
export function makePulse (Button, dropDownList) {
  return function (event) {
    var inputLength = event.target.value.length
    var attributeMaxLength = Number(event.target.attributes.maxlength.value)
    event.target.value = event.target.value.replace(/[^0-9]/g, '')

    if (event.target.id === 'mobile') { // if it's a mobile input
      if (inputLength >= attributeMaxLength) {
        // if (dropDownList.value === 'null') {
        //   dropDownList.classList.add('border')
        //   event.target.classList.remove('border')
        // } else {
        Button.classList.add('pulseButton')
        // dropDownList.classList.remove('border')
        event.target.classList.remove('border')
        // }
      } else {
        // dropDownList.classList.remove('border')
        Button.classList.remove('pulseButton')
        event.target.classList.add('border')
        if (inputLength < event.target.value.length) {
          event.target.value = event.target.defaultValue
        }
      }
    } else { // if it's not a mobile input
      if (inputLength >= attributeMaxLength) {
        Button.classList.add('pulseButton')
        event.target.classList.remove('border')
      } else {
        Button.classList.remove('pulseButton')
        event.target.classList.add('border')
      }
    }
  }
}

/* // block user and show blocked HTML div
export function block () {
  $('.loadingCard').addClass('hidden')
  loading()
  localStorage.setItem('vip', true)
  $('form').slideUp()
  $('.block').slideDown()
}
// check if user is blocked
export function isBlocked () {
  return localStorage.getItem('vip')
} */
/**
   * checks if 'exceeded' or 'blocked' is in the response.
   * @param {string} messages response from api in error cases
   */
export function shouldBlock (messages) {
  return !!(messages || []).filter(function (message) {
    var cleanMessage = message.toLowerCase()
    return cleanMessage.indexOf('exceeded') !== -1 && cleanMessage.indexOf('blocked') !== -1
  })[0]
}
export function getCountryPrefix (country) {
  switch (country) {
    case 'uae':
      return '971'
    case 'oman':
      return '968'
    default:
      console.error('No country found')
      return ''
  }
}
export function getMobilePrefix (country) {
  switch (country) {
    case 'uae':
      return ['05']
    case 'oman':
      return ['71', '72', '90', '91', '92', '93', '98', '99', '78', '79', '94', '95', '96', '97']
    default:
      return ['']
  }
}
export function getPhonePattern (country) {
  switch (country) {
    case 'uae':
      return new RegExp(/^[0-9]{10}$/)
    case 'oman':
      return new RegExp(/^[0-9]{8}$/)
    default:
      return ['']
  }
}
export function getOperator (mobile, country) {
  const omantel = ['71', '72', '90', '91', '92', '93', '98', '99']
  const ooredoo = ['78', '79', '94', '95', '96', '97']
  const etisalat = ['']
  const du = ['']
  switch (country) {
    case 'uae':
      return etisalatInfo
    case 'oman':
      if (new RegExp('^(' + omantel.join('|') + ')').test(mobile)) {
        return omantelInfo
      } else if (new RegExp('^(' + ooredoo.join('|') + ')').test(mobile)) {
        return ooredooInfo
      } else return ''
    default:
      return ['']
  }
}
export function getFormattedPhone (countryPrefix, country, phoneNumber) {
  switch (country) {
    case 'AE':
      return countryPrefix + phoneNumber.slice(1)
    case 'OM':
      return countryPrefix + phoneNumber
    default:
      return countryPrefix + phoneNumber.slice(1)
  }
}
